import { Navigate, Outlet } from "react-router-dom"
import { useWebsiteSettings } from "../hooks/useWebsiteSettings"
import { WebsiteDisabledPage } from "../pages/WebsiteDisabled"
import FullPageLoading from "@/components/FullPageLoading"
import { SomethingWentWrongPage } from "../pages/SomethingWentWrongPage"
import { isAdminPortal } from "@/utilities/domain"
import { posPath } from "@/utilities/routePaths"

export function WebsiteEnabledMiddleware() {
  // The company admin portal has no storefront and is not subject to the
  // website flag: its root goes straight to the admin app (or its login).
  const adminPortal = isAdminPortal()
  const {
    data: features,
    isLoading,
    isError,
  } = useWebsiteSettings(!adminPortal)

  if (adminPortal) return <Navigate to={posPath("dashboard")} replace />

  if (isLoading) return <FullPageLoading />
  if (isError) return <SomethingWentWrongPage />

  if (!features?.website_enabled) {
    return <WebsiteDisabledPage />
  }

  return <Outlet />
}
